import styled from "styled-components"
import {rgba} from "polished"
import Flex from "@irati/ui/src/Flex"
import {RouterLink} from "@irati/ui/src/Link"

interface StyledRouterLinkProps {
  isSelected: boolean
  isSidebarNavigation?: boolean
  isCentered?: boolean
}

interface StyledLogoProps {
  isCollapsed?: boolean
}

export const StyledLogoContainer = styled(Flex)`
  position: absolute;
  bottom: ${({theme}) => theme.spacing.three};
`

export const StyledRouterLink = styled(RouterLink).attrs({plain: true})<StyledRouterLinkProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  ${({isCentered}) => isCentered && "justify-content: center;"}
  padding: ${({theme}) => theme.spacing.oneAndHalf};
  border-radius: 5px;
  width: ${({isSidebarNavigation}) => (isSidebarNavigation ? "100%" : "85%")};

  ${({isSelected, theme}) =>
    !isSelected &&
    `
    &:hover {
      background-color: ${rgba(theme.colors.primary1_50, 0.35)}
    }
  `}

  ${({isSelected, theme}) =>
    isSelected &&
    `
    background-color: ${theme.colors.primary1_50};
  `}
  svg {
    path {
      fill: ${({theme}) => theme.colors.utility.ink};
    }
  }
`

export const StyledBusinessLogoWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70px;
`

export const SSOBusinessLogoWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 70px;
`

export const StyledLogo = styled.img<StyledLogoProps>`
  height: ${({isCollapsed, theme}) => (isCollapsed ? theme.spacing.two : theme.spacing.five)};
`
